export default __webpack_public_path__ + "static/media/LOGO_IDP_LOGIN.ecc75ef0.svg";